import { uniq } from 'lodash';
import AutoCompleteListOption from './AutoCompleteListOption';

const SELECT_ALL_OPTION = {
  value: 'SELECT_ALL',
  displayValue: 'Select All',
  searchableValue: ''
};

const SelectAllOption = ({
  options,
  selectedValues,
  onChange,
  disabled = false
}) => {
  const areAllChecked = options.every(option =>
    selectedValues.includes(option.value)
  );
  const areAllNotChecked = options.every(
    option => !selectedValues.includes(option.value)
  );
  const isIndeterminate =
    !areAllNotChecked &&
    options.some(option => !selectedValues.includes(option.value)) &&
    options;

  const onClick = () => {
    const optionsValues = options.map(option => option.value);

    if (isIndeterminate || areAllNotChecked) {
      //should select all
      const newSelectedValues = uniq([...selectedValues, ...optionsValues]);
      onChange(newSelectedValues);
    } else if (areAllChecked) {
      //should de-select all
      const newSelectedValues = selectedValues.filter(
        value => !optionsValues.includes(value)
      );
      onChange(newSelectedValues);
    }
  };

  return (
    <AutoCompleteListOption
      option={SELECT_ALL_OPTION}
      isChecked={areAllChecked}
      isIndeterminate={isIndeterminate}
      onChange={onClick}
      isDisabled={disabled}
    />
  );
};

export default SelectAllOption;
